<div class="deviations-over-time-container">
  <div class="deviations-header">
    <h4>{{ 'reportsOverTime' | translate }}</h4>
    <div class="deviations-controls">
      <app-ui-select
        [label]="'departmentSelector' | translate"
        [control]="vesselControl"
        [options]="vesselOptions"
        [isMultiple]="true"
        [selectAll]="true"
        class="control-field"
      ></app-ui-select>
      <app-ui-select
        [label]="'reportType' | translate"
        [control]="deviationControl"
        [options]="allDeviationOptions"
        [isMultiple]="true"
        [selectAll]="true"
        class="control-field"
      ></app-ui-select>
      <div class="time-period-group">
        <app-ui-select
          [label]="'timePeriod' | translate"
          [control]="timePeriodControl"
          [options]="timePeriodOptions"
          [isMultiple]="false"
          class="control-field"
        ></app-ui-select>
        <app-ui-date-range-picker
          [control]="customRangeControl"
          [maxDate]="maxDate"
        ></app-ui-date-range-picker>
      </div>
    </div>
  </div>

  <div *appLoader="isLoading">
    @if (hasData) {
      <!-- Trend indicator temporarily commented out - may be needed in the future -->
      <!-- <app-trend-indicator
        [trend]="trend"
        [trendText]="trendText"
        [periodLabel]="timePeriodLabel"
        [hasInsufficientData]="hasInsufficientData"
      ></app-trend-indicator> -->

      <div class="chart-container">
        <canvas id="reportsChart"></canvas>
      </div>

      <div class="chart-legend">
        <div class="legend-item">
          <span class="legend-dot legend-total"></span>
          <span>{{ 'totalReports' | translate }}: {{ totalDeviationsCount }}</span>
        </div>
        @if (!areAllDeviationsSelected) {
          @for (item of selectedDeviationCounts; track item.typeName) {
            <div class="legend-item">
              <span class="legend-dot" [style.background-color]="item.color"></span>
              <span>{{ item.typeName }}: {{ item.count }}</span>
            </div>
          }
        }
      </div>
    } @else {
      <div class="no-data-message">
        <p>{{ 'noDataFoundForSelectedFilters' | translate }}</p>
      </div>
    }
  </div>
</div>
